export default __webpack_public_path__ + "static/media/tooManyRequests.9664b357.svg";